import React, {useState} from 'react';
import {useScores} from "../hooks/useScore";
import {useForm} from "react-hook-form";
import {RawScore, TypeForm} from "../types";
import {useParams} from "react-router";
import {useModal} from "../Contexts/Modal";
import {getError} from "../utils/getError";


export default function FormScore({score, typeForm, category}: {score?: RawScore, typeForm: TypeForm, category: string}) {
    const {mutationCreate, mutationUpdate, isLoading} = useScores(category || "");
    const { closeModal } = useModal();
    const [customLoading, setCustomLoading] = useState(false);
    const [error, setError] = useState<string>("");

    const {
        register,
        handleSubmit,
        reset,
        formState: {errors},
    } = useForm<RawScore>({
        defaultValues: {
            date: score?.date || new Date().toISOString().substring(0, 10),
            coefficient: score?.coefficient || 1,
            score_obtained: score?.score_obtained,
            out_of: score?.out_of,
            commentary: score?.commentary
        }
    })

    const onSubmit = async (newScore: RawScore, event: React.FormEvent<HTMLFormElement>) => {
        setCustomLoading(true)
        const nativeEvent = event.nativeEvent as SubmitEvent;
        const buttonClicked = (nativeEvent.submitter as HTMLButtonElement)?.value;
        newScore.category = category
        try {
            if (typeForm == TypeForm.create){
                await mutationCreate.mutateAsync(newScore);
            } else if (typeForm == TypeForm.update){
                newScore.category = undefined
                await mutationUpdate.mutateAsync({ id: score!.name, score: newScore });
            }
            reset()
            if (buttonClicked == "submit"){
                closeModal()
            }
        } catch (error: any) {
            setError(getError(error));
        }
        setCustomLoading(false)
    }

    return (
        <form id="form-new-score" onSubmit={(e) => handleSubmit((data) => onSubmit(data, e))(e)}>
            {typeForm == TypeForm.create ? <h2>Nouvelle Note</h2>  : <h2>Modifier la note</h2> }
            <label>Note obtenue</label>
            <div>
                <input autoFocus type="number" step={"any"} {...register("score_obtained", {required: true})}
                       placeholder={"15"}/>
                <label>/</label>
                <input type="number" step={"any"} {...register("out_of", {required: true})} placeholder={"20"}/>
            </div>
            <label>Coefficient</label>
            <input type="number" step={"any"} {...register("coefficient", {required: true})}/>
            <label>Commentaire</label>
            <textarea {...register("commentary")}/>
            <label>Date</label>
            <input type={"date"} {...register("date", {required: true})}/>
            <div className={"errorMessage"}>{error}</div>
            <button type="submit" value={"submit"} disabled={customLoading}>Sauvegarder</button>
            {
                typeForm == TypeForm.create ??
                <button type="submit" value={"submitAndAddOtherScore"} disabled={customLoading}>Sauvegarder et ajouter un
                autre score</button>
            }
        </form>
    );
}